import type { Dispatch } from 'react';
import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { DELETE_WARBOX_MESSAGE } from '../constants/actions';
import type { TWarboxMessageActionTypes } from '../types';

const getErrorMessage = (error: any) =>
    error?.response?.data?.error ||
    (error instanceof Error ? error.message : 'No se pudo eliminar la nota');

export const deleteNoteMessage = async (
    dispatch: Dispatch<TWarboxMessageActionTypes>,
    messageId: string
): Promise<void> => {
    try {
        await ApiV2.delete(
            `/conversation-messages/${messageId}/delete`,
            HEADERS()
        );

        dispatch({
            type: DELETE_WARBOX_MESSAGE,
            payload: { messageId },
        });
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};
